export const DEFAULT_PANEL_WIDTH_RATIO = 0.33;
export const MAX_PANEL_WIDTH_RATIO = 0.6;
export const MIN_PANEL_WIDTH_RATIO = 0.2;
